import swal from "sweetalert2";

window.Vue = require('vue');

var _ = require('lodash');

// Bootstrap
require('./bootstrap');

// Slick
require('slick-carousel');
require('slick-lightbox');

require('jquery.easing');
require('./jquery.isonscreen.min');

/* FontAwesome */
import fontawesome from '@fortawesome/fontawesome';
import regular from '@fortawesome/fontawesome-free-regular';
import solid from '@fortawesome/fontawesome-free-solid';
import brands from '@fortawesome/fontawesome-free-brands';

fontawesome.library.add(regular);
fontawesome.library.add(solid);
fontawesome.library.add(brands);

let resizeTimer;
$(window).on('load resize', function () {

    equalHeights();
    setTimeout(equalHeights(), 1000);

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        equalHeights();
    }, 1000);
});

function countUp(facts_scrolled) {
    $('.countUp').each(function () {
        if (facts_scrolled[$(this).attr('data-countid')] === undefined && $(this).isOnScreen()) {

            let $this = $(this),
                countTo = $this.attr('data-count');

            $({countNum: 0}).animate({
                    countNum: countTo
                },
                {
                    duration: Math.floor(Math.random() * 5000) + 3000,
                    easing: 'easeOutQuad',
                    step: function () {
                        $this.text(Math.floor(this.countNum));
                        facts_scrolled[$this.attr('data-countid')] = 'true';
                    },
                    complete: function () {
                        $this.text(Math.floor(this.countNum));
                        facts_scrolled[$this.attr('data-countid')] = 'true';
                    }
                });
        }

    });
}

let facts_scrolled = [];

$(window).on('scroll', function (e) {
    countUp(facts_scrolled);
});

$(window).on('load', function (e) {
    countUp(facts_scrolled);
});

$(document).bind('mouseup touchend', function(e) {
    let container = $("div.sticky-header--desktop-navigation ul.navigation--main");
    // let containerbtn = $(".floating-btn");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('div.sticky-header--desktop-navigation ul.navigation--main li.parentnav').removeClass('hover');
    }
});

$(document).bind('mouseup touchend', function(e) {
    let container = $("a.card-image");
    // let containerbtn = $(".floating-btn");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('a.card-image').removeClass('hover');
    }
});



$(document).ready(function() {

    $('[data-action=delete-file]').click(function(e) {

        e.preventDefault();

        var el = $(this);
        var target = el.data('target');
        var route = el.data('route');

        axios.get(route)
            .then((response) =>  {
                $(target).remove();
            })
            .catch(() => {
                swal(
                    'Fehler!',
                    'Es ist ein Fehler aufgetreten!',
                    'error'
                )
            });
    });

    equalHeights();

    $('.loading-page').show();
    countUp(facts_scrolled);

    $('a.card-image').on("touchstart", function (e) {
        'use strict'; //satisfy code inspectors
        let link = $(this); //preselect the link
        if (link.hasClass('hover')) {
            return true;
        }
        else {
            link.addClass('hover');
            $('a.card-image').not(this).removeClass('hover');
            e.preventDefault();
            return false; //extra, and to make sure the function has consistent return points
        }
    });

    $('.show-mobile-search').on('click', function(e) {
        e.preventDefault();
        if($('#mobile-search--container').hasClass('active')) {
            $('#mobile-search--container').removeClass('active');
            $('.btn-search').removeClass('active');
            $('body').removeClass('nav-overflow');
        } else {
            $('#mobile-search--container').addClass('active');
            $('.btn-search').addClass('active');
            $('body').removeClass('nav-overflow');

            $('#mobile-nav--container').removeClass('active');
            $('.menu-open').addClass('show');
            $('.menu-open').removeClass('hide');
            $('.menu-close').removeClass('show');
            $('.menu-close').addClass('hide');
            $('.btn-nav').removeClass('active');
        }
    });

    let searchOpen = false;

    function closeSearch() {
        $('.search--container').removeClass('active');
        $('.show-desktop-search').removeClass('active');
        $(document).unbind('click');
        searchOpen = false;
    }

    $('.show-desktop-search').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        let searchContainer = $('.search--container');
        let searchInput = $('.search--container .search-input');

        if(searchContainer.hasClass('active')) {
            searchOpen = false;
            searchContainer.removeClass('active');
            $(this).removeClass('active');
        } else {
            searchOpen = true;
            searchContainer.addClass('active');
            $(this).addClass('active');
            searchInput.focus();
        }

        // close
        $(document).bind('click', function(d) {
            if( !$(d.target).hasClass('search-input') && !$(d.target).hasClass('btn-search-submit') ) {
                closeSearch();
            }
        });
    });


    $('.btn-nav').on('click', function(e) {
        e.preventDefault();
        if($('#mobile-nav--container').hasClass('active')) {
            $('#mobile-nav--container').removeClass('active');
            $('.menu-open').addClass('show');
            $('.menu-open').removeClass('hide');
            $('.menu-close').removeClass('show');
            $('.menu-close').addClass('hide');
            $('.btn-nav').removeClass('active');
            $('body').removeClass('nav-overflow');
        } else {
            $('#mobile-nav--container').addClass('active');
            $('.menu-open').removeClass('show');
            $('.menu-open').addClass('hide');
            $('.menu-close').addClass('show');
            $('.menu-close').removeClass('hide');
            $('.btn-nav').addClass('active');
            $('body').addClass('nav-overflow');

            $('#mobile-search--container').removeClass('active');
            $('.btn-search').removeClass('active');
        }
    });

    /* Transitions Only After Page Load */
    $('body').removeClass('preload');

    $(window).resize(function () {
        $('.slider').not('.slick-initialized').slick('resize');
    });

    $(window).on('orientationchange', function () {
        $('.slider').not('.slick-initialized').slick('resize');
    });

    /* Slick Lightbox */
    $('.lightbox').slickLightbox({
        src: 'href',
        itemSelector: ' a',
        caption: 'caption'
    });


    $('[data-action=load]').click(function(e) {
        e.preventDefault();
        let el = $(this);
        axios.post(el.data('href'), {})
            .then((response) =>  {
                console.log(response.data);
                $(el.data('target')).html(response.data);
            });


    });

    window.livewire.onError(statusCode => {
        if (statusCode === 419 || statusCode === 404 || statusCode === 500) {
            return false
        }
    });

});

function checkGrid() { // help function only
    let mode = '';
    if ($(window).width() >= 1200) {
        mode = 'XL';
    }
    else if ($(window).width() >= 992) {
        mode = 'LG';
    }
    else if ($(window).width() >= 768) {
        mode = 'MD';
    }
    else if ($(window).width() >= 576) {
        mode = 'SM';
    }
    else {
        mode = 'XS';
    }
    return mode;
}

function equalHeights() {
    let check = checkGrid();
    // console.log(check);

    if (check != 'XS') {

        // console.log($('.eqh-parent'));
        $('.eqh-parent').each(function () {
            let highestBox = 0;
            let highestTitle = 0;
            let highestText = 0;
            let highestBtn = 0;

            $(this).find('.eq-title-height').each(function () {
                if ($(this).outerHeight() > highestTitle) {
                    highestTitle = $(this).outerHeight();
                }
            });
            $(this).find('.eq-title-height').css({'height': highestTitle + "px"});

            $(this).find('.eq-text-height').each(function () {
                if ($(this).outerHeight() > highestText) {
                    highestText = $(this).outerHeight();
                }
            });
            $(this).find('.eq-text-height').css({'height': highestText + "px"});

            $(this).find('.eq-btn-height').each(function () {
                if ($(this).outerHeight() > highestBtn) {
                    highestBtn = $(this).outerHeight();
                }
            });
            $(this).find('.eq-btn-height').css({'height': highestBtn + "px"});

            $(this).find('.eq-box-height').each(function () {
                if ($(this).outerHeight() > highestTitle) {
                    highestBox = $(this).outerHeight();
                }
            });
            $(this).find('.eq-box-height').css({'height': highestBox + "px"});
        });
    }
}



// WEBPACK FOOTER //
// ./resources/js/frontend.js